var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{class:['avatar', _vm.dynamicAvatarClass],attrs:{"size":_vm.size,"color":_vm.color}},[_c('img',{attrs:{"src":_vm.avatarSrc,"referrerpolicy":"no-referrer","alt":"avatar","loading":"lazy"}})])}
var staticRenderFns = []

export { render, staticRenderFns }